export enum Action {
  ComponentClick = 'componentClick',
  ComponentMouseEnter = 'componentMouseEnter',
  ComponentMouseLeave = 'componentMouseLeave',
  PlayVideo = 'playVideo',
  HelpClick = 'helpClick',
  CloseAddPanel = 'closeAddPanel',
  CategoryOpen = 'categoryOpen',
  CategoryClick = 'categoryClick',
  SectionOpen = 'sectionOpen',
  SectionClick = 'sectionClick',
  Unmount = 'unmount',
  FedopsInteractionStarted = 'fedopsInteractionStarted',
  FedopsInteractionEnded = 'fedopsInteractionEnded',
  MouseUp = 'mouseUp',
  PathUpdate = 'pathUpdate',
  StartItemDrag = 'startItemDrag',
  OpenMediaManager = 'openMediaManager',
  BlogMainAction = 'blogMainAction',
  BlogSecondaryAction = 'blogSecondaryAction',
  BookingsMainAction = 'bookingsMainAction',
  EventsMainAction = 'eventsMainAction',
  GroupsMainAction = 'groupsMainAction',
  OnlineProgramsMainAction = 'onlineProgramsMainAction',
  FileShareMainAction = 'fileShareMainAction',
  PricingPlansMainAction = 'pricingPlansMainAction',
  ForumMainAction = 'forumMainAction',
  EventsSecondaryAction = 'eventsSecondaryAction',
  MembersAreaMainAction = 'membersAreaMainAction',
  StoresMainAction = 'storesMainAction',
  StoresSecondaryAction = 'storesSecondaryAction',
  ContentManagerMainAction = 'contentManagerMainAction',
  ContentManagerSecondaryAction = 'contentManagerSecondaryAction',
  AddBlankPage = 'addBlankPage',
  AddPreset = 'addPreset',
  AddCollection = 'addCollection',
  AddDataSet = 'addDataSet',
  AddFormDataSet = 'AddFormDataSet',
  InstallAppAndNotify = 'installAppAndNotify',
  SavedComponentsMyDesignsSectionMount = 'savedComponentsMyDesignsSectionMount',
  SavedComponentsComponentAppeared = 'savedComponentsComponentAppeared',
  SavedComponentsAdd = 'savedComponentsAdd',
  SavedComponentsRename = 'savedComponentsRename',
  SavedComponentsDelete = 'savedComponentsDelete',
  SavedComponentsStartDrag = 'savedComponentsStartDrag',
  SavedComponentsFooterCTAClick = 'savedComponentsFooterCTAClick',
  MyWidgetsStartDrag = 'myWidgetsStartDrag',
  AddRelatedApp = 'addRelatedApp',
  DragRelatedApp = 'dragRelatedApp',
  InstallWidget = 'installWidget',
  OpenWixAppMarket = 'openWixAppMarket',
  InstallSuperApp = 'installSuperApp',
  SearchButtonClick = 'searchButtonClick',
  ToggleDevMode = 'toggleDevMode',
  OpenAccountSettings = 'openAccountSettings',
  ReloadData = 'reloadData',
  AddQuickActionBar = 'AddQuickActionBar',
  AddBackToTopButton = 'AddBackToTopButton',
  AddWelcomeScreen = 'AddWelcomeScreen',
  OpenPhotoStudio = 'OpenPhotoStudio',
  AddChromeThemeColor = 'AddChromeThemeColor',
  OpenLeftbarSidePanel = 'OpenLeftbarSidePane',
  WelcomeSectionInstall = 'welcomeSectionInstall',
  CreateNewForm = 'CreateNewForm',
  AddExistingForm = 'AddExistingForm',
}
